import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de cortador hidráulico de salvamento veicular (desencarcerador).
 *
 * Representa o equipamento pesado de corte com mandíbulas curvas tipo bico
 * de papagaio, parafuso pivô central reforçado, alça tubular de transporte
 * em 360°, cilindro hidráulico central e empunhadura traseira com controle estrela.
 */
export function IconeOficinaCorte(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Mandíbula de corte esquerda com gume curvo de alta penetração */}
      <path d="M11.5 9.5C8 8.5 6.5 5.5 8 2.8c1-.3 3 2.2 3.8 5.7" />
      {/* Mandíbula de corte direita com gume curvo */}
      <path d="M12.5 9.5C16 8.5 17.5 5.5 16 2.8c-1-.3-3 2.2-3.8 5.7" />
      {/* Eixo pivô central da tesoura hidráulica */}
      <circle cx="12" cy="10" r="1.8" />
      <circle cx="12" cy="10" r="0.6" fill="currentColor" />
      {/* Alça tubular envolvente de transporte e sustentação (D-handle) */}
      <path d="M5 13.5c0-2.2 14-2.2 14 0" />
      <path d="M6.5 13.5v1.8M17.5 13.5v1.8" />
      {/* Corpo principal do cilindro hidráulico */}
      <rect x="9.5" y="11.8" width="5" height="5.5" rx="0.8" />
      {/* Empunhadura de controle traseira com válvula homem-morto / estrela */}
      <path d="M12 17.3v4.2" />
      <path d="M10 19.4h4" />
      <path d="M9.5 21.5h5" />
    </IconeProprio>
  )
}

/** Sinônimo descritivo da ferramenta hidráulica. */
export const IconeCortadorResgate = IconeOficinaCorte

/** Compatibilidade com o registro de módulos. */
export const IconeModuloCorte = IconeOficinaCorte
